import { useRouter } from 'next/router';

import { LoginState, OAuth2Error } from '@collab/libs/auth/oauth2';
import useOAuth2Exchange from '@collab/libs/auth/useOAuth2Exchange';
import { useToastErrorHandler } from '@collab/libs/errors';

import { exchangeVolvoIdApimToken } from 'libs/apim/apim.api';
import { AddedApimState } from 'libs/auth/volvoIdAuthTypes';
import { addVolvoIdAccessToken } from 'libs/volvoId/volvoIdAccessToken';

export const volvoIdAuthCallback = '/volvoid/auth/code/redirect'; // IMPORTANT! Can not be changed since it is compared against a url value in the volvoId server.

const useApimExchange = () => {
  const router = useRouter();
  const handleWithToast = useToastErrorHandler();

  const handleExchange = async (
    exchangeCode: string,
    verifier: string,
    state: LoginState,
  ) => {
    const volvoIdState = state as unknown as AddedApimState;

    const token = await exchangeApim(verifier, exchangeCode);
    addVolvoIdAccessToken(volvoIdState.apiName, token);

    router.push(state.postLoginRedirectUrl);
  };

  const handleException = async (error: OAuth2Error) => {
    if (!isDeniedByUser(error)) {
      handleWithToast(error, loginFlowErrorMsg);
    }

    router.push(error.redirectUrl ?? '/');
  };

  useOAuth2Exchange({
    handleExchange,
    handleException,
  });
};

const exchangeApim = async (verifier: string, exchangeCode: string) =>
  exchangeVolvoIdApimToken({
    codeVerifier: verifier,
    redirectUri: `${window.origin}${volvoIdAuthCallback}`,
    code: exchangeCode,
  });

const loginFlowErrorMsg = {
  text: 'We seem to have issues with Volvo ID right now. Please try again later.',
  key: 'login-apim',
};

const isDeniedByUser = (e: OAuth2Error) =>
  e.message.includes('User Denied Authorization');

export default useApimExchange;
